import { render, staticRenderFns } from "./DataFechamentoForm.vue?vue&type=template&id=5847afa6&"
import script from "./DataFechamentoForm.vue?vue&type=script&lang=js&"
export * from "./DataFechamentoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports